
/**
 * Returns the display name of a component (using educated guesses)
 * https://facebook.github.io/react/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
 */

export default Component => {
  return Component.displayName || Component.name || 'Component'
}
